






















import Vue from 'vue';
import editorConfig from '@/constants/editor';

declare global {
  interface Window {
    CKEDITOR: any;
  }
}

export default Vue.extend({
  name: 'CKEditorComponent',
  data () {
    return {
      editor: null,
      editorData: '', // to store content data
      wordCount: 0,
      characterCount: 0
    };
  },
  props: {
    maxCharacterCount: {
      type: Number,
      default: 25000
    },
    editorContent: {
      type: String,
      default: ''
    },
    isMinimized: {
      type: Boolean,
      default: false
    },
    placeHolder: {
      type: String,
      default: 'Write a message or attach a file'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isLimitExceeded (): boolean {
      return this.maxCharacterCount < this.editorData.length;
    }
  },
  mounted () {
    this.initializeCKEditor();
  },
  methods: {
    initializeCKEditor () {
      const {
        ClassicEditor,
        AccessibilityHelp,
        Alignment,
        Autoformat,
        Autosave,
        Bold,
        Essentials,
        Heading,
        Indent,
        IndentBlock,
        Italic,
        Link,
        List,
        Paragraph,
        RemoveFormat,
        SelectAll,
        TextTransformation,
        Underline,
        Undo,
        WordCount
      } = window.CKEDITOR;

      if (ClassicEditor) {
        ClassicEditor.create(this.$refs.editorContainer, {
          toolbar: editorConfig.toolbarConfig,
          plugins: [
            AccessibilityHelp,
            Alignment,
            Autoformat,
            Autosave,
            Bold,
            Essentials,
            Heading,
            Indent,
            IndentBlock,
            Italic,
            Link,
            List,
            Paragraph,
            RemoveFormat,
            SelectAll,
            TextTransformation,
            Underline,
            Undo,
            WordCount
          ],
          wordCount: {
            // container: document.querySelector('.ck-word-count'),
            displayCharacters: false,
            displayWords: false,
            onUpdate: (data: any) => {
              this.wordCount = data.words;
              this.characterCount = data.characters;
            }
          },
          heading: editorConfig.formattingConfig,
          initialData: this.editorContent,
          placeholder: this.placeHolder,
          readOnly: this.disabled
        })
          .then((editor: any) => {
            this.editor = editor;

            editor.model.document.on('change:data', () => {
              this.editorData = editor.getData();
              this.$emit('updateMessageData', this.editorData);
            });
          })
          .catch((error: any) => {
            console.error('Failed to initialize CKEditor:', error);
          });
      } else {
        console.error('CKEditor is not available.');
      }
    },
    destroyEditor () {
      if (this.editor) {
        (this.editor as any).destroy().catch((error: any) => console.error('Error destroying CKEditor:', error));
        this.editor = null;
      }
    }
  },
  beforeDestroy () {
    this.destroyEditor();
  }
});
